module.exports = __webpack_public_path__ + "img/help-white.56721b64.svg";